import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';
import RiskFactorDescriptionDropdown from './RiskFactorDescriptionDropdown';

function RiskFactorDescriptionDropdownContainer({engagementId, riskFactorId, riskFactorRelationId, onSave, isDisabled}) {
	const slice = useSelector((state) => state.aresMyRiskFactorDescriptions);

	const options = useMemo(() => {
		return slice?.descriptions?.allIds.map((desc, i) => {
			return {label: desc, value: i};
		});
	}, [slice]);

	return (
		<section className="risk-factor-description-dropdown">
			<RiskFactorDescriptionDropdown
				slice={slice}
				options={options}
				engagementId={engagementId}
				riskFactorId={riskFactorId}
				riskFactorRelationId={riskFactorRelationId}
				onSave={onSave}
				isDisabled={isDisabled}

			/>
		</section>
	);
}

export default RiskFactorDescriptionDropdownContainer;

RiskFactorDescriptionDropdownContainer.propTypes = {
	engagementId: PropTypes.number.isRequired,
	initialDescription: PropTypes.string,
	onSave: PropTypes.func.isRequired
};
